module.exports = __webpack_public_path__ + "img/logo.0db25f87.png";